import React from 'react';
import { useLocation } from 'react-router-dom';
import SiteHeader from '../../components/SiteHeader/SiteHeader';
import styles from './InscriptionPage.module.css';

function InscriptionStep2Page() {
  const { state } = useLocation();
  const careerLabel = state?.careerLabel || '';
  const planLabel = state?.planLabel || '';
  const planTotal = state?.planTotal ?? null;
  const email = state?.email || '';

  return (
    <div className={styles.page}>
      <SiteHeader />

      <main className={styles.main}>
        <img
          className={styles.odmLogo}
          src="/logos/logos_2.png"
          alt="Logo ODM"
          onError={(e) => {
            e.target.src = '/logos/logos_1.png';
          }}
        />
        <div className={styles.titleBlock}>
          <h1 className={styles.pageTitle}>Inscripciones</h1>
          <div className={styles.carreraRow}>
            <span className={styles.carreraLabel}>
              Crea tu inscripción en la carrera de :
            </span>
            <div className={styles.selectWrapper}>
              <div className={styles.carreraReadonly}>
                <span>{careerLabel || 'Carrera seleccionada'}</span>
                <span className={styles.selectChevron} aria-hidden="true">&#8964;</span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.formCard}>
          {planLabel && (
            <p className={styles.planSummary}>
              Plan seleccionado: <strong>{planLabel}</strong>
              {planTotal != null && (
                <> — Total: <strong>{planTotal.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 })}</strong></>
              )}
            </p>
          )}
          <h2 className={styles.step2Title}>Confirma tu correo electrónico</h2>
          <p className={styles.step2Text}>
            Te enviamos un correo de verificación
            {email ? <> a <strong>{email}</strong></> : ' a la dirección que registraste'}.
            <br />
            Por favor, revisa tu bandeja de entrada y haz clic en el botón "Confirmar correo" para continuar con tu inscripción.
          </p>
          <p className={styles.step2Warning}>
            ⚠️ Si no lo encuentras, revisa tu carpeta de spam o correo no deseado.
          </p>
          <p className={styles.step2Text}>
            Una vez confirmado, podrás avanzar al siguiente paso del proceso.
          </p>
        </div>
      </main>
    </div>
  );
}

export default InscriptionStep2Page;
